import Node from './node';

export default class Meta extends Node {
  clone() {
    return new Meta(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
